import React, { ReactNode } from 'react';
import {
  PricesWrapper,
  ProductPriceBadge,
  ReferencePrice,
  SellingPrice,
  OriginalTotal,
} from './wrappers';
import { Column, Columns } from '../Columns/wrappers';

interface IProductPrice {
  isDiscounted: boolean;
  sellingDisplayPrice: string;
  originalDisplayPrice: string;
  displayReferencePrice: string;
  referencePricePrefix: string;
  componentPricePrefix: string;
  componentDisplayPrice: string;
  displayOriginalPrice: boolean;
  hasPriceFlag: boolean;
  priceDesign?: TPriceDesign | null;
  badge?: ReactNode;
  inline?: boolean;
  size?: 'large' | 'small';
}

export default function StyledProductPrices({
  isDiscounted,
  sellingDisplayPrice,
  originalDisplayPrice,
  displayReferencePrice,
  referencePricePrefix,
  componentPricePrefix,
  componentDisplayPrice,
  displayOriginalPrice,
  badge,
  hasPriceFlag,
  priceDesign,
  inline,
  size,
}: IProductPrice) {
  return (
    <PricesWrapper $size={size} $inline={inline}>
      <Columns className="valign-middle width-auto">
        <Column>
          <SellingPrice $priceDesign={priceDesign} $discount={isDiscounted}>
            {sellingDisplayPrice}
          </SellingPrice>
        </Column>
        {badge && (
          <Column>
            <ProductPriceBadge>{badge}</ProductPriceBadge>
          </Column>
        )}
      </Columns>
      {isDiscounted && (
        <>
          <ReferencePrice>
            {referencePricePrefix} {displayReferencePrice}
          </ReferencePrice>
          {displayOriginalPrice && <OriginalTotal>({originalDisplayPrice})</OriginalTotal>}
        </>
      )}
      {!isDiscounted && componentDisplayPrice && hasPriceFlag && (
        <>
          <ReferencePrice>
            {componentPricePrefix} {componentDisplayPrice}
          </ReferencePrice>
        </>
      )}
    </PricesWrapper>
  );
}
